<template>
  <!-- <v-autocomplete
    class="mt-2"
    :items="items"
    :rules="[rules.required]"
    :loading="isLoading"
    :error-messages="error"
    @input="$emit('input', item)"
    label="Veículo*"
    v-model="item"
    item-text="plate"  
    return-object  
    clearable
    outlined
    dense    
  ></v-autocomplete> -->
  <div>
    <v-text-field
      class="mt-2"
      placeholder="Digite a placa do veículo que deseja adicionar (Ex: ABC-1234)"
      label="Placa*"
      v-model="plate"
      :rules="[rules.required]"
      :loading="isLoading"
      :error-messages="error"      
      clearable
      outlined
      dense
      append-icon="search"
      @click:append="listVehicles"
    ></v-text-field>
  </div>
  
</template>

<script>
import vehicleService from '@/services/vehicle.service';

export default {
  name: 'OrderVehicleSelectForInclusion',

  props: {
    value: {
      type: Object,
      default: null
    }
  },

  data: () => ({
    isLoading: false,
    
    plate: null,

    error: null,    

    item: null,

    rules: {
      required: value => !!value || "Esse campo deve ser preenchido"
    },    
  }),

  methods: {
    listVehicles() {      
      if (!this.plate) return;

      this.isLoading = true;
      this.error = null;
      vehicleService.listForInclusion(this.plate).subscribe(response => {
        this.item = response;
        this.$emit('input', this.item);
        this.isLoading = false;
      }, () => {
        this.error = 'Erro ao buscar o veículo';
        this.isLoading = false;
      });
    }
  },
};
</script>